<template>
  <div id="content" class="page-title">
    <mt-navbar v-model="selected">
      <mt-tab-item id="1">
        <div style="font-size: 16px;">图文教程</div>
      </mt-tab-item>
      <mt-tab-item id="2">
        <div style="font-size: 16px">视频教程</div>
      </mt-tab-item>
    </mt-navbar>
    <!-- tab-container -->
    <mt-tab-container v-model="selected">
      <mt-tab-container-item id="1">
        <p></p>
         <!-- <img src="../../assets/nobrand/vl0_service_manual.png" class="bg" /> -->
        <img src="../../assets/brand/vl0_service_manual.png" class="bg" />
      </mt-tab-container-item>
      <mt-tab-container-item id="2">
        <p>APP下载安装教程</p>
        <!--        object-fit: fill;-->
        <div class="voide">
          <video width="90%" poster="../../assets/video/down.png" controls="controls"
            style="border:1px solid black;border-radius:10px">
            <source src="../../assets/video/down_nobrand.mp4" type="video/mp4" class="bg" />
          </video>
        </div>
        <p>APP注册登录教程</p>
        <div class="voide">
          <video width="90%" poster="../../assets/video/login.png" controls="controls"
            style="border:1px solid black;border-radius:10px">
            <source src="../../assets/video/login.mp4" type="video/mp4" class="bg" />
          </video>
        </div>
        <p>锁体绑定教程</p>
        <div class="voide">
          <video width="90%" poster="../../assets/video/bind.png" controls="controls"
            style="border:1px solid black;border-radius:10px">
            <source src="../../assets/video/bind.mp4" type="video/mp4" class="bg" />
          </video>
        </div>
        <p>安卓手机如何设置权限</p>
        <div class="voide">
          <video width="90%" poster="../../assets/video/permission.png" controls="controls"
            style="border:1px solid black;border-radius:10px">
            <source src="../../assets/video/permission.mp4" type="video/mp4" class="bg" />
          </video>
        </div>
        <p>如何绑定微信提醒</p>
        <div class="voide">
          <video width="90%" poster="../../assets/video/wechat.png" controls="controls"
            style="border:1px solid black;border-radius:10px">
            <source src="../../assets/video/wechat.mp4" type="video/mp4" class="bg" />
          </video>
        </div>
      </mt-tab-container-item>
    </mt-tab-container>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        selected: '1', //注意就是这里，默认选字符串数字，不然初始没展示；
      }
    }
  }
</script>

<style scoped>
  .bg {
    width: 100%;
    height: 100%;
    margin: 0 auto;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .indexicon {
    font-size: 22px;
    color: #26a2ff;
    display: inline-block;
    width: 30px;
    vertical-align: middle;
  }

  .page-title {
    font-family: blod 黑体;
    font-weight: 900;
    font-size: 20px;
    margin: 20px auto;
    display: block;
    line-height: 1;
  }

  .voide {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/bind/bind.vue